import { Component, EventEmitter, forwardRef, ViewEncapsulation, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { FnInputValueAccessor } from '../../../core/model/fn-input.value.accessor';


/**
 * This Component is Used to Create CheckBox Field.
 * To use this component import FnInputModule in Module.
 */
@Component({
  selector: 'fn-checkbox',
  templateUrl: './fn-input-checkbox.component.html',
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FnInputCheckboxComponent),
      multi: true
    }
  ]
})
export class FnInputCheckboxComponent extends FnInputValueAccessor<any> {

  @Input() label: string;
  @Input() name = '';
  @Input() id = 'id';
  @Input() labelClass = '';
}
